import { render, staticRenderFns } from "./passwordSetting.vue?vue&type=template&id=c58b38da&"
import script from "./passwordSetting.vue?vue&type=script&lang=js&"
export * from "./passwordSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports